
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
class SavePanel extends Vue {
  @Prop({ default: "EN" }) readonly languageID!: string;
  test = "";

  discardChanges(): void {
    this.$emit("discardChanges");
  }
  saveChanges(value: boolean): void {
    this.$emit("saveChanges", value);
  }
}

export default SavePanel;
